import { getLanguageCodeFromLocale, SupportedLocale } from '@sz/l10n';

export const locales = Object.values(SupportedLocale).map(
  getLanguageCodeFromLocale
);

export const defaultLocale = 'en';
